import React from 'react';
import AreaTitle from '../AreaTitle';
import ContactForm from '../contact-form/ContactForm';

class Contact extends React.Component {
  componentDidMount() {
    this.props.updateState({
      phase: 4
    });
  }

  render() {
    return (
      <div className="view-content">
        <AreaTitle text="Yhteydenotto"/>
        <ContactForm state={this.props.state} updateState={this.props.updateState}></ContactForm>
      </div>
    );
  }
}

export default Contact;
